import { Check, Sprout, Orbit, Rocket, Circle } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

const PHASES = [
  {
    testid: "roadmap-phase-1",
    icon: Sprout,
    phase: "roadmap.p1",
    title: "roadmap.p1t",
    status: "roadmap.inProgress",
    items: [
      { key: "roadmap.i1", done: true },
      { key: "roadmap.i2", done: true },
      { key: "roadmap.i3" },
      { key: "roadmap.i4" },
    ],
  },
  {
    testid: "roadmap-phase-2",
    icon: Orbit,
    phase: "roadmap.p2",
    title: "roadmap.p2t",
    status: "roadmap.upcoming",
    items: [
      { key: "roadmap.i5" },
      { key: "roadmap.i6" },
      { key: "roadmap.i7" },
      { key: "roadmap.i8" },
    ],
  },
  {
    testid: "roadmap-phase-3",
    icon: Rocket,
    phase: "roadmap.p3",
    title: "roadmap.p3t",
    status: "roadmap.upcoming",
    items: [
      { key: "roadmap.i9" },
      { key: "roadmap.i10" },
      { key: "roadmap.i11" },
      { key: "roadmap.i12" },
    ],
  },
];

export const Roadmap = () => {
  const { t } = useLanguage();
  return (
  <section id="roadmap" className="scroll-mt-24 px-5 py-24 sm:px-8">
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <Eyebrow>{t("roadmap.eyebrow")}</Eyebrow>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display mt-5 text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
          {t("roadmap.t1")} <span className="text-flow">{t("roadmap.t2")}</span>
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-3">
        {PHASES.map((p, i) => (
          <Reveal key={p.testid} delay={0.1 * i}>
            <div
              data-testid={p.testid}
              className="flex h-full flex-col rounded-3xl border border-purple-500/15 bg-[#0E0E16] p-7 transition-all hover:-translate-y-1 hover:border-[#14F195]/50"
            >
              <div className="flex items-center justify-between">
                <span className="font-display rounded-full border border-[#9945FF]/40 bg-[#9945FF]/10 px-3 py-1 text-xs font-bold uppercase tracking-wider text-purple-300">
                  {t(p.phase)}
                </span>
                <p.icon size={20} className="text-[#14F195]" />
              </div>
              <div className="mt-5 flex items-center justify-between gap-3">
                <h3 className="font-display text-2xl font-bold text-[#F5F3FF]">
                  {t(p.title)}
                </h3>
                <span
                  className={`font-display inline-flex shrink-0 items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-bold ${
                    p.status === "roadmap.inProgress"
                      ? "border-[#14F195]/40 text-[#14F195]"
                      : "border-purple-500/40 text-purple-300"
                  }`}
                >
                  <span
                    className={`h-1.5 w-1.5 rounded-full ${
                      p.status === "roadmap.inProgress"
                        ? "bg-[#14F195] animate-pulse-dot"
                        : "bg-purple-400"
                    }`}
                  />
                  {t(p.status)}
                </span>
              </div>
              <ul className="mt-5 flex-1 space-y-3">
                {p.items.map((item) => (
                  <li
                    key={item.key}
                    className="flex items-start gap-3 text-sm text-gray-300"
                  >
                    {item.done ? (
                      <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-[#14F195]/20">
                        <Check size={11} className="text-[#14F195]" />
                      </span>
                    ) : (
                      <Circle size={16} className="mt-0.5 shrink-0 text-gray-600" />
                    )}
                    {t(item.key)}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="font-display mt-8 text-center text-xs font-bold text-gray-500">
          {t("roadmap.footnote")}
        </p>
      </Reveal>
    </div>
  </section>
  );
};
